<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            请假退费审核
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                        <el-button type="primary" :disabled="disabledAdd"  @click.native="toggleModalAdd">通过</el-button>
                        <el-button type="success" :disabled="disabledEdit" @click="toggleModalEdit">不通过</el-button>
                    
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline>
                                    <div style="padding:10px;" v-for="item in props.row.refundSettleItemList" :key="item">
                                        <span v-if="item.refundType=='room'" style="color: #99a9bf;margin-left:20px;">床位退费：</span> 
                                        <span v-if="item.refundType=='nursing'" style="color: #99a9bf;margin-left:20px;">护理退费：</span> 
                                        <span v-if="item.refundType=='other'" style="color: #99a9bf;margin-left:20px;">其它退费：</span> 
                                        <span style="color:#99999;margin-left:20px;">{{item.refundMoney}} 元</span>   
                                    </div>
                                    
                                </el-form>
                            </template>
                        </el-table-column>

                        <el-table-column prop="elderlyName" label="姓名"></el-table-column>
                        <el-table-column prop="startTime" :formatter="formatterTime" label="开始时间"></el-table-column>
                        <el-table-column prop="reportTime" :formatter="formatterTime" label="销假时间"></el-table-column>

                        <el-table-column prop="dayNumber" label="请假天数(天)"></el-table-column>

                        <el-table-column prop="refundMoney"  label="退费总额（元）"></el-table-column>

                        <el-table-column prop="refundType"  label="退费类型">
                            <template slot-scope="scope">
                                <el-tag type="success" effect="plain" v-show="scope.row.refundType==1">余额充值</el-tag>
                                <el-tag type="danger" effect="plain" v-show="scope.row.refundType==2">现金退款</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="isCheck"  label="审核状态">
                            <template slot-scope="scope">
                                <el-tag type="danger"  effect="plain" v-show="scope.row.isCheck==0">未审核</el-tag>
                                <el-tag type="success" effect="plain" v-show="scope.row.isCheck==1">通过</el-tag>
                                <el-tag type="danger" effect="plain" v-show="scope.row.isCheck==2">不通过</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="登记时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                row:null,
                elderlyName:'',
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                showModalAdd:false,
                showModalEdit:false,
                searchBuild:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,

            }
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row = row;
                if(row.isCheck==0){
                    if(this.menuButtonList.indexOf("通过")!=-1){
                        this.disabledAdd =false;
                    }
                    if(this.menuButtonList.indexOf("不通过")!=-1){
                        this.disabledEdit =false;
                    }
                }else{
                    this.disabledAdd =true;
                    this.disabledEdit =true;
                }
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            toggleModalAdd:function(){
                var message='通过后退费金额将直接充值到余额, 是否继续?'
                if(this.row.refundType==2){
                    message='通过后退费金额将提交到财务待办, 是否继续?'
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '通过',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.submit(1);
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            submit(isCheck){
                this.loading = true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/Check",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        refundSettleCode:this.row.refundSettleCode,
                        isCheck:isCheck
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        var message='操作成功！';
                        if(isCheck==1){
                            message=this.row.refundType==1?'退费金额已充值到余额！':'退费金额已提交到财务待办！'
                        }
                        this.$message.success(message)
                        this.getList();
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            
            toggleModalEdit:function(){
                this.$confirm('确认不通过, 是否继续?', '提示', {
                    confirmButtonText: '不通过',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.submit(2);
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/AuditList",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledAdd = true;
                    this.disabledEdit = true;
                    if(response.data.error == 0){
                        console.log(response.data.data)
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: rgb(121, 187, 255);
        color:#fff;
    }
</style>
